import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import viscoThermalDist03m from "./components/visco-thermal-dist-03m";
import viscoThermalDist3m from "./components/visco-thermal-dist-3m";
import viscoThermalDist9m from "./components/visco-thermal-dist-9m";
import viscoThermalDist15m from "./components/visco-thermal-dist-15m";
import viscoThermalDist21m from "./components/visco-thermal-dist-21m";
import viscoThermalDist30m from "./components/visco-thermal-dist-30m";

const principle: Slide = {
  description:
    "The difference between phase and group velocities is illustrated for phase velocity smaller than, equal to, and larger than group velocity. It is then proposed to see how a burst centred at 68 Hz is changed due to the dispersion, either of the Klein Gordon type (at 2 propagation distances and 3 cut-off frequencies fc) or in a tube of 2 mm-radius with visco-thermal losses for several propagation distances. Due to the dispersion, different frequency components of the burst propagate at different velocity, hence dispersing the burst profile.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 4],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Dispersion in a tube with visco-thermal losses",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "button",
                    options: {},
                    items: [
                      { name: "propag. of 0.3 m" },
                      { name: "3 m" },
                      { name: "9 m" },
                      { name: "15 m" },
                      { name: "21 m" },
                      { name: "30 m" },
                    ],
                  },
                ],
                controlsPosition: "bottom",
                extraContent: [[], [], [], [], [], []],
                components: [
                  viscoThermalDist03m,
                  viscoThermalDist3m,
                  viscoThermalDist9m,
                  viscoThermalDist15m,
                  viscoThermalDist21m,
                  viscoThermalDist30m,
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
